import { useSelector } from 'react-redux';
import { selectUser } from 'redux/user/selectors';
import { User, RoleCode } from 'types';

export function useCurrentUser() {
  const user: User | null = useSelector(selectUser);

  return { user }
}

export function useCurrentUserHasRoles(roleCodes: RoleCode[]): { loading: boolean, isUserHasRoles: boolean } {
  const { user } = useCurrentUser();

  return {
    loading: !user,
    isUserHasRoles: user?.roles ? roleCodes.some(roleCode => user.roles!.map((role) => role.code).includes(roleCode)) : false,
  }
}

export function useIsCurrentUserSuperAdmin(): { loading: boolean, isCurrentUserSuperAdmin: boolean } {
  const { user } = useCurrentUser();

  return {
    loading: !user,
    isCurrentUserSuperAdmin: user ? isSuperAdmin(user) : false,
  }
}

export function isSuperAdmin(user: User): boolean {
  return Boolean(user.roles?.map((role) => role.code).includes(RoleCode.SUPER_ADMIN))
}

export function isTenantAdmin(user: User): boolean {
  return Boolean(user.roles?.map((role) => role.code).includes(RoleCode.TENANT_ADMIN))
}

export function useCanSwitchTenancy(): { loading: boolean, canSwitchTenancy: boolean } {
  const { user } = useCurrentUser();

  return {
    loading: !user,
    canSwitchTenancy: user ? (isSuperAdmin(user) || isTenantAdmin(user)) : false,
  }
}
